import { AlertBadge } from './AlertBadge'
import { HeadingWithHighlight } from './HeadingWithHighlight'
import { StatCards } from './StatCards'
import { GuidanceTip } from './GuidanceTip'
import type { PortfolioAlertData } from '../types'

interface VariationPortfolioAlertProps {
  data: PortfolioAlertData
}

export function VariationPortfolioAlert({ data }: VariationPortfolioAlertProps) {
  return (
    <div className="flex flex-col">
      <AlertBadge label="Regular Fund Detected" />

      <HeadingWithHighlight
        before="Your "
        highlight="returns are impacted"
        after=" by the high expense ratio of Regular funds"
      />

      <StatCards
        amount={data.totalCommissionsPaid}
        amountLabel="Paid extra due to high expense ratio"
        count={data.totalRegularFunds}
        countLabel="Total Regular funds"
      />
      {/* <GuidanceTip text="Unlock your Regular to Direct Plan and switch to direct funds tax-efficiently" /> */}
    </div>
  )
}
